import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Stack } from "react-bootstrap";
import { LomavisGrowthCard, LomavisGrowthCardProps } from "../../../organisms/cards/LomavisGrowthCard";
import "./LomavisGrowthCardSectionTemplate.css";
import {LomavisCard1} from "@/lomavisSharedUi/atoms/cards/LomavisCard1"; // Assuming you have some styles for the grid

interface LomavisGrowthCardSectionTemplateProps {
    title: string;
    entries: LomavisGrowthCardProps[];
}

export const LomavisGrowthCardSectionTemplate: React.FC<LomavisGrowthCardSectionTemplateProps> = ({
                                                                                                      title,
                                                                                                      entries,
                                                                                                  }) => {
    return (
        <Stack gap={3}>

            <LomavisCard1 title={title} className={"pb-3"} showDownloadButton={true}>

                <Row className="g-0 lomavis-grid mt-n2">
                    {entries.map((entry, index) => (
                        <Col
                            key={index}
                            xs={12}
                            sm={6}
                            lg={4}
                            xl={3}
                            className="lomavis-grid-col position-relative"
                        >
                            <div className="h-100">
                                <LomavisGrowthCard {...entry} />
                            </div>
                        </Col>
                    ))}
                </Row>

            </LomavisCard1>
        </Stack>
    );
};
